import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 16px;
  transition: all 0.3s ease-in-out;
  opacity: ${(props) => (props.$isAnimating ? 1 : 0)};
`;

export const ModalContainer = styled.div`
  display: flex;
  max-width: 460px;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  gap: 16px;
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  font-family: Figtree;
  letter-spacing: -0.3px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const CloseButton = styled.button`
  margin-left: auto;
  background: transparent;
  border: none;
  color: white;
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;
  z-index: 10;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const SelectedPlanInfo = styled.div`
  border-radius: 12px;
  background: ${(props) => props.$gradient};
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  height: 46px;
  padding: 12px 24px;
  line-height: normal;
  letter-spacing: -0.09px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PaymentOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.3s ease-in-out;
`;

export const PaymentOption = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const PaymentQuestion = styled.div`
  width: 100%;
  opacity: ${(props) => (props.$muted ? 0.6 : 1)};

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  cursor: pointer;

  span {
    color: #fff;
    font-family: Figtree;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.09px;
  }
`;

export const PaymentIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2877d9;
  flex-shrink: 0;
`;

export const PaymentIconGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #081120;

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
`;

export const PaymentAnswer = styled.div`
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  font-family: Figtree;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin-inline: 5px;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const PaymentDescription = styled.div`
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  font-family: Figtree;

  /* display: flex;
  flex-direction: row; */
`;

export const Link = styled.span`
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  font-family: Figtree;
  cursor: pointer;
  text-decoration: underline;
`;

export const ModalLink = styled.span`
  color: #fff;
  cursor: pointer;
  text-decoration: underline;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  opacity: 0.9;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 0.75;
  }
`;

export const Text = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: ${(props) => (props.$bold ? "800" : "500")};
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.08px;
  text-decoration: ${(props) => (props.$link ? "underline" : "none")};
  cursor: ${(props) => (props.$link ? "pointer" : "default")};
  &:hover {
    opacity: ${(props) => (props.$link ? ".85" : "1")};
  }
`;

export const PaymentButton = styled.button`
  width: 100%;
  background: linear-gradient(180deg, #4d9dff 0%, #2877d9 100%);
  color: #fff;
  border: none;
  padding: 16px 24px;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  gap: 5px;
  font-family: Figtree;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px #4d9dff;
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
  }
`;
